import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";
import { API_SERVER } from "../utils/urlBack_End";
import { isArray } from "lodash";

// La BD/endpoints usan YYYY/MM; la URL usa YYYY-MM (el "/" no va en el path).
// Normalizacion unica aca; los componentes nunca tocan el slash.
export const urlToBackendFecha = (f) => (f ? f.replace("-", "/") : f);
export const backendToUrlFecha = (f) => (f ? f.replace("/", "-") : f);

export const facturasApi = createApi({
  reducerPath: "facturasApi",
  baseQuery: baseQuery(`${API_SERVER}/facturas`),
  tagTypes: [
    "FacturaPlanes",
    "FacturaAfecta",
    "FacturaTareas",
    "FacturaTarea",
    "ProcesoFacturacion",
    "FacturasSinSucursal",
    "PeriodoFacturacion",
  ],
  endpoints: (builder) => ({
    getDetalleFacturaPlanes: builder.query({
      query: (id) => `/detalleFacturaPlanes/${id}`,
      providesTags: ["FacturaPlanes"],
    }),
    obtenerPromedioFacturasEmitidasPorCliente: builder.query({
      query: ({ rut, sucursales, fechaInicio, fechaFin }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }
        return {
          url: "/promedioFacturasEmitidasPorCliente",
          method: "GET",
          params,
        };
      },
    }),
    obtenerClientesMayorCantidadFacturasPagadas: builder.query({
      query: ({ tipo, rut, sucursales, fechaInicio, fechaFin }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }
        return {
          url: `/clientesMayorCantidadFacturasPagadas/${tipo}`,
          method: "GET",
          params,
        };
      },
    }),
    getFacturasDeTareasEmpleadoEmitidas: builder.query({
      query: (rutEmpleado) =>
        `/facturasDeTareasEmpleadoEmitidas/${rutEmpleado}`,
    }),
    getPendientePorFacturarTareasEmpleado: builder.query({
      query: (rutEmpleado) =>
        `/pendientePorFacturarTareasEmpleado/${rutEmpleado}`,
    }),
    getRecaudadoTareasEspecialesEmpleado: builder.query({
      query: (rutEmpleado) =>
        `/recaudadoTareasEspecialesEmpleado/${rutEmpleado}`,
    }),
    obtenerFacturasEmitidas: builder.query({
      query: ({ rut, estadoFactura, fecha, sucursales }) => {
        const params = { estadoFactura, fecha };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        return {
          url: `/facturasEmitidas/${rut}`,
          method: "GET",
          params,
        };
      },
    }),
    getFacturasPlanes: builder.query({
      query: ({
        id,
        page = 0,
        perPage = 10,
        mesInicio = new Date().getMonth() + 1 <= 9
          ? `0${new Date().getMonth() + 1}`
          : new Date().getMonth() + 1,
        anioInicio = new Date().getFullYear(),
        mesFin = new Date().getMonth() + 1 <= 9
          ? `0${new Date().getMonth() + 1}`
          : new Date().getMonth() + 1,
        anioFin = new Date().getFullYear(),
        search = null,
      }) => {
        return {
          url: `/planes/sucursal/${id}`,
          method: "GET",
          params: {
            page: page,
            perPage: perPage,
            mesInicio: mesInicio,
            anioInicio: anioInicio,
            mesFin: mesFin,
            anioFin: anioFin,
            search: search,
          },
        };
      },
      providesTags: ["FacturaPlanes"],
    }),
    getFacturasPorSucursal: builder.query({
      query: ({
        sucursales,
        page = 0,
        perPage = 10,
        mesInicio = new Date().getMonth() + 1 <= 9
          ? `0${new Date().getMonth() + 1}`
          : new Date().getMonth() + 1,
        anioInicio = new Date().getFullYear(),
        mesFin = new Date().getMonth() + 1 <= 9
          ? `0${new Date().getMonth() + 1}`
          : new Date().getMonth() + 1,
        anioFin = new Date().getFullYear(),
        search = null,
      }) => {
        return {
          url: `/facturasPorSucursal`,
          method: "GET",
          params: {
            page: page,
            perPage: perPage,
            mesInicio: mesInicio,
            anioInicio: anioInicio,
            mesFin: mesFin,
            anioFin: anioFin,
            search: search,
            sucursales: isArray(sucursales)
              ? sucursales.map((sucursal) => sucursal.refSucursal)
              : sucursales,
          },
        };
      },
      providesTags: ["FacturaPlanes"],
    }),
    cambiarSucursal: builder.mutation({
      query: ({ id, tipo, nuevaSucursal, antiguaSucursal }) => ({
        url: `${id}/cambiarSucursal/${nuevaSucursal}`,
        method: "PATCH",
        body: {
          tipo,
          antiguaSucursal,
        },
      }),
      invalidatesTags: ["FacturaPlanes"],
    }),
    getFacturasPlanesExportar: builder.query({
      query: (id) => {
        return {
          url: `/planes/sucursal/exportar/${id}`,
          method: "GET",
        };
      },
      providesTags: ["FacturaPlanes"],
    }),
    getFacturasTotalExportar: builder.query({
      query: ({
        sucursales,
        mesInicio,
        anioInicio,
        mesFin,
        anioFin,
        incluyeRemuneraciones,
      }) => {
        return {
          url: `facturasTotal/sucursal/exportar`,
          method: "GET",
          params: {
            sucursales: isArray(sucursales)
              ? sucursales.map((sucursal) => sucursal.refSucursal)
              : sucursales,
            mesInicio,
            anioInicio,
            mesFin,
            anioFin,
            incluyeRemuneraciones,
          },
        };
      },
      providesTags: ["FacturaPlanes"],
    }),

    getFacturasAfecta: builder.query({
      query: (id) => `/afecta/sucursal/${id}`,
      providesTags: ["FacturaAfecta"],
    }),
    getFacturasPlanesCliente: builder.query({
      query: (refCliente) => `/planes/cliente/${refCliente}`,
      providesTags: ["FacturaPlanes"],
    }),
    obtenerFacturasSinSucursal: builder.query({
      query: () => "/facturasSinSucursal",
      providesTags: ["FacturasSinSucursal"],
    }),
    getFacturasPlanesEmpleado: builder.query({
      query: (refEmpleado) => `/planes/empleado/${refEmpleado}`,
      providesTags: ["FacturaPlanes"],
    }),
    getFacturasTareasCliente: builder.query({
      query: (refCliente) => `/tareas/cliente/${refCliente}`,
      providesTags: ["FacturaTareas"],
    }),
    getFacturasTareasEmpleado: builder.query({
      query: (refEmpleado) => `/tareas/empleado/${refEmpleado}`,
      providesTags: ["FacturaTareas"],
    }),
    getFacturasTareas: builder.query({
      query: ({
        id,
        page = 0,
        perPage = 10,
        mesInicio = new Date().getMonth() + 1 <= 9
          ? `0${new Date().getMonth() + 1}`
          : new Date().getMonth() + 1,
        anioInicio = new Date().getFullYear(),
        mesFin = new Date().getMonth() + 1 <= 9
          ? `0${new Date().getMonth() + 1}`
          : new Date().getMonth() + 1,
        anioFin = new Date().getFullYear(),
        search = null,
      }) => {
        return {
          url: `/tareas/sucursal/${id}`,
          method: "GET",
          params: {
            page: page,
            perPage: perPage,
            mesInicio: mesInicio,
            anioInicio: anioInicio,
            mesFin: mesFin,
            anioFin: anioFin,
            search: search,
          },
        };
      },
      providesTags: ["FacturaTareas"],
    }),
    getVencimientoFacturas: builder.query({
      query: (refCliente) => `/vencimientoFactura/${refCliente}`,
      providesTags: ["FacturaPlanes"],
    }),
    getTokenNotaCredito: builder.query({
      query: (folioFactura) => `/tokenNotaCredito/${folioFactura}`,
    }),
    getTokenFolioRef: builder.query({
      query: (params) =>
        `/facturasPlanesTareas/${params.folio}/${params.tipoFactura}`,
      providesTags: ["ProcesoFacturacion"],
    }),
    getFacturasCliente: builder.query({
      query: (refCliente) => `/cliente/${refCliente}`,
    }),
    getFacturasClientes: builder.query({
      query: () => `/clientes`,
    }),
    notificarDatosFaltantes: builder.mutation({
      query: ({ sucursal, ...body }) => ({
        url: `/notificarDatosFaltantes/${sucursal}`,
        method: "POST",
        body,
      }),
    }),
    facturarManual: builder.mutation({
      query: (body) => ({
        url: `/facturarManual`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["FacturaPlanes"],
    }),
    addCrearFacturaPlan: builder.mutation({
      query: (body) => ({
        url: `/planes`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["FacturaPlanes"],
    }),
    addCrearFacturaTarea: builder.mutation({
      query: (body) => ({
        url: `/tareas`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["FacturaTareas"],
    }),
    generarDTE: builder.mutation({
      query: ({ sucursal, body }) => ({
        url: `/obtenerFolios/${sucursal}`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["ProcesoFacturacion"],
    }),
    updateVencimientoFactura: builder.mutation({
      query: ({ sucursal, ...body }) => ({
        url: `/vencimientoFactura`,
        method: "PUT",
        params: { sucursal },
        body,
      }),
      invalidatesTags: ["FacturaPlanes"],
    }),

    updateEstadoFacturaTarea: builder.mutation({
      query: ({ id, body }) => ({
        url: `/tareas/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["FacturaTareas"],
    }),
    updateEstadoFacturaPlan: builder.mutation({
      query: ({ id, body }) => ({
        url: `/planes/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["FacturaPlanes"],
    }),
    updateEstadoFacturaAfecta: builder.mutation({
      query: ({ id, body }) => ({
        url: `/planes/facturaAfecta/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["FacturaAfecta"],
    }),

    updateEstadoCorreFacturaPlanes: builder.mutation({
      query: ({ id, body }) => ({
        url: `/tareas/empleado/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["FacturaTareas"],
    }),
    updateEstadoCorreFacturaAfecta: builder.mutation({
      query: ({ id, body }) => ({
        url: `/planes/empleado/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["FacturaAfecta"],
    }),
    updateEstadoCorreFacturaTareas: builder.mutation({
      query: ({ id, body }) => ({
        url: `/afecta/empleado/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["FacturaTareas"],
    }),
    obtenerDocumentoPorToken: builder.query({
      query: (token) => ({
        url: `/facturaOpenFactura/obtenerDocumentoPorToken/${token}`,
      }),
    }),
    obtenerDocumentoReferencia: builder.query({
      query: (folio) => ({
        url: `/facturaOpenFactura/obtenerDocumentoReferencia/${folio}`,
      }),
    }),
    enlazarFacturaASucursal: builder.mutation({
      query: ({ idFactura, ...body }) => ({
        url: `/enlazarFacturaASucursal/${idFactura}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["FacturasSinSucursal"],
    }),
    enlazarFacturasASucursalMasivamente: builder.mutation({
      query: (body) => ({
        url: `/enlazarFacturasASucursalMasivamente`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["FacturasSinSucursal"],
    }),
    getFacturaTareasID: builder.query({
      query: ({ sucursal, refTarea }) => `/tareas/${sucursal}/${refTarea}`,
      providesTags: (result, error, { refTarea }) => [
        { type: "FacturaTarea", id: refTarea },
      ],
    }),
    validatePaymentSupervisor: builder.mutation({
      query: ({ idFactura, refTarea, ...body }) => ({
        url: `/validarPagoTareaSupervisor/${idFactura}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { refTarea }) => [
        { type: "FacturaTarea", id: refTarea },
      ],
    }),
    getFacturasPendientesPagoEmpleados: builder.query({
      query: ({ sucursal, fechaInicio, fechaFin, empleado }) => ({
        url: "/getFacturasPendientesPagoEmpleados",
        params: { sucursal, fechaInicio, fechaFin, empleado },
      }),
      providesTags: ["FacturaTareas"],
    }),
    registrarPagoEmpleado: builder.mutation({
      query: ({ idFactura, ...body }) => ({
        url: `/registrarPagoEmpleado/${idFactura}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["FacturaTareas"],
    }),
    anularFactura: builder.mutation({
      query: ({ id, tipo, motivoAnulacion, confirmarEliminacionAbonos }) => ({
        url: `/${id}/${tipo}/anular`,
        method: "POST",
        body: {
          motivoAnulacion,
          confirmarEliminacionAbonos,
        },
      }),
      invalidatesTags: (result, error, { tipo }) => {
        if (tipo === "PLAN") {
          return ["FacturaPlanes"];
        } else if (tipo === "TAREA") {
          return ["FacturaTareas", "FacturaTarea"];
        }
        return ["FacturaPlanes", "FacturaTareas"];
      },
    }),
    corregirMontoFactura: builder.mutation({
      query: ({ id, tipo, tipoCorreccion, montoDelta, motivoCorreccion }) => ({
        url: `/${id}/${tipo}/corregir-monto`,
        method: "POST",
        body: {
          tipoCorreccion,
          montoDelta,
          motivoCorreccion,
        },
      }),
      invalidatesTags: (result, error, { tipo }) => {
        if (tipo === "PLAN") {
          return ["FacturaPlanes"];
        } else if (tipo === "TAREA") {
          return ["FacturaTareas", "FacturaTarea"];
        }
        return ["FacturaPlanes", "FacturaTareas"];
      },
    }),
    // Pagos vigentes de una factura. El modal de corrección lo necesita para no dejar
    // reducir el monto por debajo de lo ya abonado: ese dato no viene en el listado de
    // facturas, así que antes leía `factura.totalAbonado` y ahí siempre valía 0.
    getAbonosFactura: builder.query({
      query: ({ id, tipo }) => `/${id}/${tipo}/abonos`,
      providesTags: (result, error, { tipo }) =>
        tipo === "TAREA" ? ["FacturaTareas"] : ["FacturaPlanes"],
    }),
    sugerirGlosa: builder.mutation({
      query: (body) => ({
        url: `/sugerirGlosa`,
        method: "POST",
        body,
      }),
    }),
    obtenerDatosEmisor: builder.query({
      query: (rut) => ({ url: `/datosEmisor/${rut}` }),
      keepUnusedDataFor: 86400, // 24h — datos del emisor casi no cambian
    }),
    getEstadoPeriodo: builder.query({
      // arg: { sucursal, fecha } — fecha en formato URL (YYYY-MM) u omitida = periodo vigente
      query: ({ sucursal, fecha }) => {
        const qs = fecha ? `?fecha=${urlToBackendFecha(fecha)}` : "";
        return `/periodo/${sucursal}/estado${qs}`;
      },
      providesTags: ["PeriodoFacturacion"],
    }),
    prepararPeriodo: builder.mutation({
      query: (sucursal) => ({
        url: `/periodo/${sucursal}/preparar`,
        method: "POST",
      }),
      invalidatesTags: ["PeriodoFacturacion"],
    }),
    facturarPeriodo: builder.mutation({
      query: (sucursal) => ({
        url: `/periodo/${sucursal}/facturar`,
        method: "POST",
      }),
      invalidatesTags: ["PeriodoFacturacion"],
    }),
    reintentarFacturacion: builder.mutation({
      // arg: { sucursal, items? } — sin items reintenta todos los ERROR
      query: ({ sucursal, items }) => ({
        url: `/periodo/${sucursal}/reintentar`,
        method: "POST",
        body: items ? { items } : {},
      }),
      invalidatesTags: ["PeriodoFacturacion"],
    }),
    editarCantidadItem: builder.mutation({
      query: ({ sucursal, id, cantidad }) => ({
        url: `/periodo/${sucursal}/item/${id}/cantidad`,
        method: "PATCH",
        body: { cantidad },
      }),
      invalidatesTags: ["PeriodoFacturacion"],
    }),
    listarPeriodosFacturacion: builder.query({
      query: (sucursal) => `/periodos/${sucursal}`,
      providesTags: ["PeriodoFacturacion"],
    }),
  }),
});

export const {
  useGenerarDTEMutation,
  useGetDetalleFacturaPlanesQuery,
  useGetFacturaTareasIDQuery,
  useGetFacturasAfectaQuery,
  useGetFacturasPlanesClienteQuery,
  useGetFacturasPlanesEmpleadoQuery,
  useGetFacturasPlanesQuery,
  useGetFacturasTareasClienteQuery,
  useGetFacturasTareasEmpleadoQuery,
  useGetFacturasTareasQuery,
  useObtenerFacturasSinSucursalQuery,
  useGetTokenNotaCreditoQuery,
  useGetVencimientoFacturasQuery,
  useGetTokenFolioRefQuery,
  useGetFacturasPorSucursalQuery,
  useObtenerFacturasEmitidasQuery,
  useGetFacturasDeTareasEmpleadoEmitidasQuery,
  useGetFacturasTotalExportarQuery,
  useGetPendientePorFacturarTareasEmpleadoQuery,
  useGetRecaudadoTareasEspecialesEmpleadoQuery,
  useObtenerPromedioFacturasEmitidasPorClienteQuery,
  useObtenerDocumentoPorTokenQuery,
  useObtenerDocumentoReferenciaQuery,
  useObtenerClientesMayorCantidadFacturasPagadasQuery,
  useEnlazarFacturaASucursalMutation,
  useEnlazarFacturasASucursalMasivamenteMutation,
  useLazyObtenerFacturasEmitidasQuery,
  useLazyObtenerClientesMayorCantidadFacturasPagadasQuery,
  useLazyObtenerDocumentoReferenciaQuery,
  useLazyObtenerPromedioFacturasEmitidasPorClienteQuery,
  useLazyGetRecaudadoTareasEspecialesEmpleadoQuery,
  useLazyGetPendientePorFacturarTareasEmpleadoQuery,
  useLazyGetFacturasDeTareasEmpleadoEmitidasQuery,
  useLazyObtenerDocumentoPorTokenQuery,
  useLazyObtenerFacturasSinSucursalQuery,
  useLazyGetFacturasTotalExportarQuery,
  useLazyGetFacturasPorSucursalQuery,
  useLazyGetTokenFolioRefQuery,
  useLazyGetDetalleFacturaPlanesQuery,
  useLazyGetFacturaTareasIDQuery,
  useLazyGetFacturasAfectaQuery,
  useLazyGetFacturasPlanesClienteQuery,
  useLazyGetFacturasPlanesEmpleadoQuery,
  useLazyGetFacturasPlanesQuery,
  useLazyGetFacturasTareasClienteQuery,
  useLazyGetFacturasTareasEmpleadoQuery,
  useLazyGetFacturasTareasQuery,
  useLazyGetTokenNotaCreditoQuery,
  useCambiarSucursalMutation,
  useAddCrearFacturaPlanMutation,
  useAddCrearFacturaTareaMutation,
  useFacturarManualMutation,
  useUpdateEstadoCorreFacturaAfectaMutation,
  useUpdateEstadoCorreFacturaPlanesMutation,
  useUpdateEstadoCorreFacturaTareasMutation,
  useUpdateEstadoFacturaAfectaMutation,
  useUpdateEstadoFacturaPlanMutation,
  useUpdateEstadoFacturaTareaMutation,
  useUpdateVencimientoFacturaMutation,
  useGetFacturasPlanesExportarQuery,
  useLazyGetFacturasPlanesExportarQuery,
  useGetFacturasClienteQuery,
  useGetFacturasClientesQuery,
  useLazyGetFacturasClienteQuery,
  useLazyGetFacturasClientesQuery,
  useValidatePaymentSupervisorMutation,
  useGetFacturasPendientesPagoEmpleadosQuery,
  useLazyGetFacturasPendientesPagoEmpleadosQuery,
  useRegistrarPagoEmpleadoMutation,
  useAnularFacturaMutation,
  useCorregirMontoFacturaMutation,
  useGetAbonosFacturaQuery,
  useSugerirGlosaMutation,
  useObtenerDatosEmisorQuery,
  useNotificarDatosFaltantesMutation,
  useGetEstadoPeriodoQuery,
  usePrepararPeriodoMutation,
  useFacturarPeriodoMutation,
  useReintentarFacturacionMutation,
  useEditarCantidadItemMutation,
  useListarPeriodosFacturacionQuery,
} = facturasApi;
